import React, {Component} from "react";

export class FormNothing extends Component {
    render() {
        return <>
        </>;
    }
}